module.exports = __webpack_public_path__ + "static/CRS_08_new-fd61704827a1db7db691f7a20192e40e.svg";